module.exports = __webpack_public_path__ + "static/media/N-Mall-003-mobile.49cda5b6.webp";